/**
 * <TutorCorrectionReview> — l'avis du tuteur sur la correction de Sam (molecule).
 *
 * Sous la copie corrigée, dans la fiche (`<TutorActivityDetailsModal>`) comme au centre du live
 * (`<TutorLiveActivityView>`) : « Cette correction est-elle juste ? » — « Oui » / « À revoir », l'avis
 * de la fiche (`<CorrectionFeedback>`, ses deux pouces). Plus de mention de la bêta : la correction
 * n'est plus visible du tuteur seul, l'élève la voit aussi (Wajih, 02/11).
 */
import React from "react"

import { CorrectionFeedback, type UICorrectionFeedback } from "../CorrectionFeedback"

export type TutorCorrectionReviewProps = {
    value: UICorrectionFeedback | null
    onChange: (value: UICorrectionFeedback) => void
    submitting?: boolean
    testID?: string
}

const TEXTS = {
    feedback: { question: "Cette correction est-elle juste ?", yes: "Oui", no: "À revoir" },
}

export function TutorCorrectionReview(props: TutorCorrectionReviewProps) {
    const { value, onChange, submitting, testID } = props
    return (
        <CorrectionFeedback
            value={value}
            onChange={onChange}
            submitting={submitting}
            texts={TEXTS.feedback}
            testID={testID}
        />
    )
}
